import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";

import InstitutionPageStyle from "./style";
import ShowInstitutions from "./show";

import DashboardHeader from "@/components/app/DashboardHeader";
import { useCheckPermissionAccess } from "@/hooks/useCheckPermissionAccess";
import ROUTE_CONSTANTS from "@/constants/route-constants";
import { OperationAccess, PagesAccess } from "@/constants/enums/permissions";

export default function Institution() {
    const createAccess = useCheckPermissionAccess(PagesAccess.INSTITUTION, OperationAccess.CREATE);

    return (
        <InstitutionPageStyle>
            <DashboardHeader
                title="Institutions"
                titleSuffix={
                    createAccess && (
                        <Button
                            color="primary"
                            component={Link}
                            to={ROUTE_CONSTANTS.USER_MANAGEMENT.INSTITUTIONS.ADD_NEW.ROOT.ABSOLUTE}
                            variant="contained"
                        >
                            Add New Institution
                        </Button>
                    )
                }
            />
            <Box className="center">
                <ShowInstitutions />
                <br />
            </Box>
        </InstitutionPageStyle>
    );
}
